"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.toggleSizes = void 0;

var _react = _interopRequireDefault(require("react"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * **Controls allow the user to select options.**
 *
 * There are 2 sizes: Small, Medium
 *
 * There are 2 states: Checked, Disabled
 */
var Toggle = function Toggle(_ref) {
  var name = _ref.name,
      size = _ref.size,
      checked = _ref.checked,
      disabled = _ref.disabled,
      _onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(_Switch.default, {
    color: "secondary",
    size: size,
    checked: checked,
    name: name,
    disabled: disabled,
    onChange: function onChange() {
      return _onChange();
    },
    disableRipple: true
  });
};

Toggle.propTypes = {
  /** Name prop of form element */
  name: _propTypes.default.string,

  /** Checked state of the checkbox */
  checked: _propTypes.default.bool,

  /** Disable state of the checkbox */
  disabled: _propTypes.default.bool,

  /** The size of the toggle component */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /** Function to call onChange event */
  onChange: _propTypes.default.func.isRequired
};
Toggle.defaultProps = {
  name: null,
  size: "medium",
  checked: false,
  disabled: false
};
var toggleSizes = ['small', 'medium'];
exports.toggleSizes = toggleSizes;
var _default = Toggle;
exports.default = _default;